export default "/images/63521132a21ea0594ffb6b874556b6fd.avif";